module.exports = __webpack_public_path__ + "static/media/planet-level14.40ce01b4.png";